module.exports = __webpack_public_path__ + "img/blank-profile-picture.3973cd6b.svg";